import { useMutation } from 'react-query'
import { endpoints } from '@app/api/config'
import { ApiErrorResponse } from 'BackendApi'
import { apiAuthClient } from '@app/services/apiAuthClient'

const patchResetDowngradeFreemium = async () => {
  const apiResponse = await apiAuthClient.patch(
    endpoints.patchResetDowngradeFreemium
  )
  return apiResponse
}

export const UseResetDowngradeFreemium = () =>
  useMutation<unknown, ApiErrorResponse>(patchResetDowngradeFreemium)
